import { useEffect } from "react";
import "./EmptyState.css";

const EmptyState = ({
	icon: Icon,
	title,
	description,
	actionButton,
	variant = "default",
}) => {
	// Block scroll when empty state is displayed
	useEffect(() => {
		document.documentElement.classList.add("scroll-blocked");

		return () => {
			document.documentElement.classList.remove("scroll-blocked");
		};
	}, []);

	return (
		<div
			className={`empty-state ${
				variant === "error" ? "empty-state-error" : ""
			}`}
		>
			<Icon size={48} />
			<h3>{title}</h3>
			<p>{description}</p>
			{actionButton && (
				<button className="ios-button action" onClick={actionButton.onClick}>
					{actionButton.icon && <actionButton.icon size={18} />}
					{actionButton.text}
				</button>
			)}
		</div>
	);
};

export default EmptyState;
